import React from 'react'
import ReactAudioPlayer from 'react-audio-player'
import AudioPlayer from 'react-h5-audio-player'
import 'react-h5-audio-player/lib/styles.css'
import { ReadMore } from 'components/readMore'

export const Testimony = ({
  title,
  titleSup,
  infos,
  location,
  text,
  sound,
  soundCaption
}) => {
  return (
    <div className='testimony ui vertical inverted segment'>
      <div className='ui container center aligned'>
        <div className='testimony-titlesup'>{titleSup}</div>
        <div className='testimony-header'>«{title}»</div>
        {!sound && <hr />}
        {/* <hr />
        <div className='testimony-infos'>
          {infos}, {location}
        </div> */}
        {/* <figure className='audio'>
          <audio
            src={require(`../../sounds/${sound}`)}
            controls
          >
            test
          </audio>
          <figcaption>{soundCaption}</figcaption>
  </figure> */}
      </div>
      <div className='ui text container'>
        {/* <ReactAudioPlayer
          src='https://interaktiv.tagesanzeiger.ch/2020/strassenlaerm/seon_2020-09-05-17-56-14.mp3'
          controls
        /> */}
        {sound && (
          <AudioPlayer
            showJumpControls={false}
            src={require(`../../sounds/${sound}`)}
          />
        )}
        <div className='testimony-text ta text'>
          <ReadMore text={text} />
        </div>
      </div>
    </div>
  )
}
